var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeanut = function SvgPeanut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#peanut_svg__a)",
    d: "M210 119.007h-70c-52 0-80 17.998-80 17.998C60 146.963 74 169 126 169s84-21.997 84-49.993"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#peanut_svg__b)",
    d: "M194 104.01s5.21 4.119 8.33 11.848c.21.51.67 1.15.67 2.149 0 6.999-60 21.997-103 21.997-16 0-29-3.999-29-7.999 0-4.999 18.11-13.588 24.1-14.557S186 104.01 194 104.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#peanut_svg__c)",
    d: "M142.17 129.796c47.16-4.06 57.26-18.378 66.23-13.198.98.57 1.6 1.399 1.6 2.399 0 5.999-17.61 19.617-66.83 23.987-16.2 1.44-29.17 2.01-40.17 2.01-34 0-43-5.72-43-7.999C60 110.529 134 101 172 101c12 0 20.78 1.29 22 3 4.34 6.079-29.75 5.489-58.85 10.568-30.36 5.289-62.21 14.988-62.21 17.257 0 2.03 22.08 2.03 69.24-2.029z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "peanut_svg__a",
    x1: 71.86,
    x2: 212.759,
    y1: 154.392,
    y2: 129.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "peanut_svg__b",
    x1: 84.46,
    x2: 207.008,
    y1: 136.245,
    y2: 105.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1988BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#218CBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#3797C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#5BAACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#8EC4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#CDE5F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "peanut_svg__c",
    x1: 64.97,
    x2: 215.168,
    y1: 139.164,
    y2: 107.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1988BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#3094C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#6CB3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#CBE4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgPeanut;